import { makeActionCreator } from '../../../../utilities'
import { ExtricationConstants } from './extrication.constants'

export const saveExtrication = makeActionCreator(ExtricationConstants.SAVE_EXTRICATION, 'data')
export const resetState = makeActionCreator(ExtricationConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(ExtricationConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(ExtricationConstants.SET_STATE, 'extricationState')
export const setDateTime = makeActionCreator(ExtricationConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(ExtricationConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectExtricationProcedure = makeActionCreator(ExtricationConstants.ON_SELECT_EXTRICATION)
export const setUpdateInputRows = makeActionCreator(ExtricationConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSuccessfulAttempt = makeActionCreator(ExtricationConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(ExtricationConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(ExtricationConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  ExtricationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  ExtricationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
